// extracted by mini-css-extract-plugin
export default {"nav-item":"yOqosL","navItem":"yOqosL","active":"BW2XKF"};